import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AbstractControl, FormGroup } from "@angular/forms";
import { AuthorizedRole, ReportTypes } from "src/openapi-gen/models";
import { InputMasks } from "src/app/core/constants/input.masks";
import { TransactionTypes } from "src/app/core/constants/transaction.types";

export interface ValidationMessage {
    type: string,
    message: string
}

@Component({
    selector: 'app-base',
    template: ``,
    styles: [],
    standalone: true
})
export class BaseComponent implements AfterViewInit {
    ANY_ROLE = AuthorizedRole.Any;
    SUPER_ADMIN_ROLE = AuthorizedRole.SuperAdmin;
    ADMINISTRATOR_ROLE = AuthorizedRole.Admin;
    EMPLOYEE_ROLE = AuthorizedRole.Employee;
    HELPER_ROLE = AuthorizedRole.Helper;

    AGENCY_REPORT = ReportTypes.Agency;
    FOOD_SOURCE_REPORT = ReportTypes.FoodSource;
    WASTE_REPORT = ReportTypes.Waste;

    INCOMING = TransactionTypes.Incoming;
    OUTGOING = TransactionTypes.Outgoing;
    KITCHEN = TransactionTypes.Kitchen;
    WASTE = TransactionTypes.Waste;

    ALTERNATIVE_WASTE_NAME = 'Food Scraps';

    readonly ngxMasks = InputMasks;
    readonly MAX_DISPLAY_CHARACTER_LIMIT: number = 50;

    ngAfterViewInit() {
        document.querySelector('mat-sidenav-content')?.scrollTo(0,0);
    }
    
    /**
        Determines if any errors exist on a given form control.    
        
        Usage Example:
        <!-- Used a scenario where two error messages could show at the same time. -->
        <mat-error *ngIf="anyErrors(form.controls.email, form_validation_messages.email)">
            {{ getErrorMessage(form.controls.email, form_validation_messages.email) }}
        </mat-error>
     */
    anyErrors(formControl: AbstractControl, formErrorChecks: ValidationMessage[]): boolean {
        return formErrorChecks.some(check => formControl.hasError(check.type)) && formControl.touched;
    }

    /** 
        Will only retrieve the first found error message on the form control. 
    */ 
    getErrorMessage(formControl: AbstractControl, formErrorChecks: ValidationMessage[]): string {
        return formErrorChecks.find(check => formControl.hasError(check.type)).message;
    }

    /**
        Removes all current errors from a form entirely. Useful in scenarios where after 
        a form is reset, validation error message still show on the UI and need to be cleared.
     */
    clearFormErrors(form: FormGroup) {
        Object.keys(form.controls).forEach(key => {
            form.get(key).setErrors(null);
        });
    }
}
